// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add and Upload Section */
.add-section,
.upload-section {
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center; 
  border-radius: 8px;
  margin: 20px auto;
  padding: 20px;
}

.add-section p {
    font-size: 20px;
    font-weight: bold;
}

.upload-section p {
    font-size: 20px;
    font-weight: bold;
}

.blacklist-option-wrap {
  display: flex;
  align-items: center;
  margin: 15px 0;
  width: 50%;
}

.blacklist-option-wrap label {
  flex: 1 1; 
  text-align: left;  /* Align labels properly */
  margin-right: 10px; 
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap; /* Prevents wrapping */
}

.blacklist-option-wrap input,
.blacklist-option-wrap textarea {
  flex: 4 1; 
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 0 5px 5px 0;
  width: 96%; 
}

.blacklist-option-wrap textarea {
  resize: vertical; 
  min-height: 70px;
}

/* Adjust prefix alignment */
.blacklist-option-wrap .prefix {
  padding: 10px 8px;
  font-size: 14px;
  background-color: #f1f1f1;
  color: #373435;
  border: 1px solid #ccc;
  border-radius: 5px 0 0 5px;
  display: flex;
  align-items: center;
  /* margin-bottom: 8px; */
  margin-left: 10px;
}

  .blacklist-btn {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
  }

  .blacklist-btn .add-button {
    padding: 10px 20px;
    border-radius: 4px;
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e;
    cursor: pointer;
  }
  
  .blacklist-btn .add-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  .blacklist-btn .cancel-button {
    padding: 10px 20px;
    border-radius: 4px;
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
    cursor: pointer;
  }

  .blacklist-btn .cancel-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  

/* View/Delete style */
.view-section {
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
    border: 1px solid #ddd;
    border-radius: 8px; 
    border-radius: 10px;
    margin: 20px auto; 
  }
  
  .view-section-all-wrap {
    text-align: right;
    margin-bottom: 15px;
  }
  
  .list-all-button {
    background-color: #44a67e;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .list-all-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  
  .view-search-section {
    display: flex;
    gap: 20px;
  }
  
  .view-search-section .search-wrap {
    flex: 1 1;
  }

  .search-wrap label {
    text-align: left;
  }
  
  .label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
  }
  
  .view-search-section .input-group {
    display: flex;
    align-items: center;
  }
  
  .view-search-section .input-group .prefix {
    padding: 10px;
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    color: #373435;
    border-right: none;
    border-radius: 5px 0 0 5px;
    margin-bottom: 8px;
  }
  
  .view-search-section .input-group input {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-left: none;
    border-radius: 0 5px 5px 0;
    margin-bottom: 8px;
  }
  
  .view-description-select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
  }
  
  .view-blacklist-search-button {
    display: flex;
    margin-top: 10px;
    background-color: #373435;
    color: #ffcc29;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .view-blacklist-search-button-mobile {
    display: flex;
    background-color: #373435;
    color: #ffcc29;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .view-blacklist-search-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  .view-blacklist-search-button-mobile:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  

  /* Blacklist Table Structure */
  .blacklist-contacts-table-container p {
    text-align: left;
    color: #373435;
  }

  .blacklist-contacts-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .blacklist-contacts-table th,
  .blacklist-contacts-table td {
    text-align: left;
    padding: 10px;
    border: 1px solid #ddd;
    color: #373435;
  }
  
  .blacklist-contacts-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #373435;
    text-transform: uppercase;
    text-align: left;
  }
  
  .blacklist-contacts-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .blacklist-contacts-table tr:hover {
    background-color: #f1f1f1;
  }

  .download-blacklist-button {
    background-color: #44a67e;
    padding: 10px 12px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .blacklist-buttons-wrap {
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
  }

  .download-blacklist-button {
    background-color: #44a67e;
    padding: 10px 12px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .download-blacklist-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  .delete-selected-button {
    background-color: #fb3d4e;
    padding: 8px 10px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .delete-selected-button:hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  
  @media screen and (max-width: 950px) {
    .blacklist-option-wrap {
        width: 90%;
      }
  }

   /* ==========Message Note Style=========  */
   .blacklist-option-wrap .input-alert-combine {
    display: flex;
    flex-direction: column;
    width: 80%;
  }

  
  .blacklist-option-wrap .file-name { 
    font-size: 15px;
    color: #000;
  }


  .blacklist-option-wrap small {
    /* color: #373435;
    font-size: 12px;
    text-align: start; */
    font-size: 13px !important;
  font-style: italic;
    color: #44a67e;
    text-align: start;
    font-weight: 550;
  }

  /* response message */
  .blacklistResponseMsg {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
    margin: 10px auto;
  }

  .blacklistResponseMsg p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }
  

  /* Pagination Styles */
  .pagination-controls {
    display: flex;
    justify-content: end;
    align-items: center;
    margin: 10px 0 30px;
  }
  
  .pagination-button {
    margin: 0 5px;
    padding: 5px 10px;
    background-color: #ffcc29;
    color: #373435;
    border: none;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .pagination-button:disabled {
    background-color: #d6d6d6;
    cursor: not-allowed;
  }
  
  .pagination-info {
    margin: 0 10px;
    color: #373435;
  }
  
  .wrap-blacklist-contacts {
    margin: 0 40px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/BlacklistContacts/BlacklistContacts.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB,GAAG,0BAA0B;EAC7C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;EAEE;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;;AAGF,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;EAEA;IACE,qFAAqF;EACvF;;;EAGA,8BAA8B;EAC9B;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qFAAqF;EACvF;;;EAGA;IACE;QACI,UAAU;MACZ;EACJ;;GAEC,2CAA2C;GAC3C;IACC,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;;EAGA;IACE,eAAe;IACf,WAAW;EACb;;;EAGA;IACE;;wBAEoB;IACpB,0BAA0B;EAC5B,kBAAkB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;;EAGA,sBAAsB;EACtB;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB","sourcesContent":["/* Add and Upload Section */\r\n.add-section,\r\n.upload-section {\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  background-color: #fff;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center; \r\n  justify-content: center; \r\n  border-radius: 8px;\r\n  margin: 20px auto;\r\n  padding: 20px;\r\n}\r\n\r\n.add-section p {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.upload-section p {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.blacklist-option-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  margin: 15px 0;\r\n  width: 50%;\r\n}\r\n\r\n.blacklist-option-wrap label {\r\n  flex: 1; \r\n  text-align: left;  /* Align labels properly */\r\n  margin-right: 10px; \r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  white-space: nowrap; /* Prevents wrapping */\r\n}\r\n\r\n.blacklist-option-wrap input,\r\n.blacklist-option-wrap textarea {\r\n  flex: 4; \r\n  padding: 10px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0 5px 5px 0;\r\n  width: 96%; \r\n}\r\n\r\n.blacklist-option-wrap textarea {\r\n  resize: vertical; \r\n  min-height: 70px;\r\n}\r\n\r\n/* Adjust prefix alignment */\r\n.blacklist-option-wrap .prefix {\r\n  padding: 10px 8px;\r\n  font-size: 14px;\r\n  background-color: #f1f1f1;\r\n  color: #373435;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px 0 0 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  /* margin-bottom: 8px; */\r\n  margin-left: 10px;\r\n}\r\n\r\n  .blacklist-btn {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .blacklist-btn .add-button {\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .blacklist-btn .add-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  .blacklist-btn .cancel-button {\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .blacklist-btn .cancel-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n\r\n/* View/Delete style */\r\n.view-section {\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); \r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    border-radius: 10px;\r\n    margin: 20px auto; \r\n  }\r\n  \r\n  .view-section-all-wrap {\r\n    text-align: right;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .list-all-button {\r\n    background-color: #44a67e;\r\n    color: #fff;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .list-all-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n  .view-search-section {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .view-search-section .search-wrap {\r\n    flex: 1;\r\n  }\r\n\r\n  .search-wrap label {\r\n    text-align: left;\r\n  }\r\n  \r\n  .label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .view-search-section .input-group {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .view-search-section .input-group .prefix {\r\n    padding: 10px;\r\n    background-color: #f1f1f1;\r\n    border: 1px solid #ccc;\r\n    color: #373435;\r\n    border-right: none;\r\n    border-radius: 5px 0 0 5px;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .view-search-section .input-group input {\r\n    flex: 1;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-left: none;\r\n    border-radius: 0 5px 5px 0;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .view-description-select {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .view-blacklist-search-button {\r\n    display: flex;\r\n    margin-top: 10px;\r\n    background-color: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 10px 15px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .view-blacklist-search-button-mobile {\r\n    display: flex;\r\n    background-color: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 10px 15px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .view-blacklist-search-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  .view-blacklist-search-button-mobile:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n\r\n  /* Blacklist Table Structure */\r\n  .blacklist-contacts-table-container p {\r\n    text-align: left;\r\n    color: #373435;\r\n  }\r\n\r\n  .blacklist-contacts-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .blacklist-contacts-table th,\r\n  .blacklist-contacts-table td {\r\n    text-align: left;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    color: #373435;\r\n  }\r\n  \r\n  .blacklist-contacts-table th {\r\n    background-color: #f2f2f2;\r\n    font-weight: bold;\r\n    color: #373435;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .blacklist-contacts-table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .blacklist-contacts-table tr:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n\r\n  .download-blacklist-button {\r\n    background-color: #44a67e;\r\n    padding: 10px 12px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .blacklist-buttons-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px auto;\r\n  }\r\n\r\n  .download-blacklist-button {\r\n    background-color: #44a67e;\r\n    padding: 10px 12px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .download-blacklist-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  .delete-selected-button {\r\n    background-color: #fb3d4e;\r\n    padding: 8px 10px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .delete-selected-button:hover {\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  \r\n  @media screen and (max-width: 950px) {\r\n    .blacklist-option-wrap {\r\n        width: 90%;\r\n      }\r\n  }\r\n\r\n   /* ==========Message Note Style=========  */\r\n   .blacklist-option-wrap .input-alert-combine {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 80%;\r\n  }\r\n\r\n  \r\n  .blacklist-option-wrap .file-name { \r\n    font-size: 15px;\r\n    color: #000;\r\n  }\r\n\r\n\r\n  .blacklist-option-wrap small {\r\n    /* color: #373435;\r\n    font-size: 12px;\r\n    text-align: start; */\r\n    font-size: 13px !important;\r\n  font-style: italic;\r\n    color: #44a67e;\r\n    text-align: start;\r\n    font-weight: 550;\r\n  }\r\n\r\n  /* response message */\r\n  .blacklistResponseMsg {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .blacklistResponseMsg p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n\r\n  /* Pagination Styles */\r\n  .pagination-controls {\r\n    display: flex;\r\n    justify-content: end;\r\n    align-items: center;\r\n    margin: 10px 0 30px;\r\n  }\r\n  \r\n  .pagination-button {\r\n    margin: 0 5px;\r\n    padding: 5px 10px;\r\n    background-color: #ffcc29;\r\n    color: #373435;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .pagination-button:disabled {\r\n    background-color: #d6d6d6;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-info {\r\n    margin: 0 10px;\r\n    color: #373435;\r\n  }\r\n  \r\n  .wrap-blacklist-contacts {\r\n    margin: 0 40px;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
